import { Component } from '@angular/core';

@Component({
  selector: 'app-accordion-group',
  standalone: true,
  imports: [],
  templateUrl: './accordion-group.component.html'
})
export class AccordionGroupComponent {
}
